import { ImagesService } from '@services/image-service';
import { ImageLoaderProps } from 'next/image';
import React, { useMemo, useRef } from 'react';
import { ImageComponent, withImageProps, VCImageProps } from '../vc-image';

export type SrcsetOptsType = {
  width: string;
  height: string;
  descriptor: string;
};

const CMS_IMAGE_SIZES = {
  edito: `(max-width: 375px) 320w, (max-width: 768px) 420w, (max-width: 990px) 780w, 1246w`,
};

const CMS_SIZES = [
  { width: '375', height: '328', descriptor: '320w' },
  { width: '768', height: '768', descriptor: '420w' },
  { width: '990', height: '860', descriptor: '780w' },
  { width: '1246', height: '910', descriptor: '1246w' },
];

function buildCmsImageUrl({ src, width, quality }: ImageLoaderProps, srcSetOpts: SrcsetOptsType[] | undefined): string {
  /*
  options : 
  - crop // to defined how to
  - fit // TO BE DEFINED
  - h // 
  - q // use quality
  */
  const srcSets = srcSetOpts || CMS_SIZES;
  const option = srcSets.find((size) => width <= Number(size.width)) || srcSets[srcSets.length - 1];

  const cmsUrl = ImagesService.buildCmsUrl(src, {
    w: option.width,
    h: option.height,
    q: quality,
  });

  return cmsUrl;
}

function cmsImageLoader(getSrcSetOpts: () => SrcsetOptsType[] | undefined) {
  return ({ src, width, quality }: ImageLoaderProps): string => {
    return buildCmsImageUrl({ src, width, quality }, getSrcSetOpts());
  };
}

const CompWrap = (getSrcSetOpts: () => SrcsetOptsType[] | undefined) => {
  return withImageProps(ImageComponent, cmsImageLoader(getSrcSetOpts), CMS_IMAGE_SIZES);
};

export default function CMSImage({ srcSetOpts, ...restProps }: VCImageProps & { srcSetOpts?: SrcsetOptsType[] }) {
  const srcSetOptsRef = useRef(srcSetOpts);
  srcSetOptsRef.current = srcSetOpts;

  const Comp = useMemo(() => {
    return CompWrap(() => srcSetOptsRef.current);
  }, []);
  return React.createElement(Comp, restProps);
}
